import { Link } from "react-router-dom";
import { ArrowUpRight, Star } from "lucide-react";
import { useState } from "react";
import { isFavorite, toggleFavorite } from "@/lib/favorites";
import { toolIcon } from "@/lib/toolsData";

export const ToolCard = ({ tool }) => {
  const Icon = toolIcon(tool);
  const [fav, setFav] = useState(isFavorite(tool.slug));
  const soon = tool.status === "soon";

  const onFav = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(tool.slug);
    setFav((v) => !v);
  };

  const inner = (
    <>
      <div className="flex items-start justify-between">
        <span className={`flex h-10 w-10 items-center justify-center border border-border ${soon ? "bg-muted text-muted-foreground" : "bg-muted text-primary group-hover:bg-primary group-hover:text-white"} transition-colors duration-200`}>
          {Icon && <Icon className="h-5 w-5" strokeWidth={2} />}
        </span>
        {soon ? (
          <span className="overline border border-border bg-muted px-2 py-1 text-[10px] text-muted-foreground">Soon</span>
        ) : (
          <div className="flex items-center gap-1.5">
            <button data-testid={`fav-${tool.slug}`} onClick={onFav} aria-label="Toggle favorite" className={`transition-colors ${fav ? "text-[#FFC107]" : "text-muted-foreground hover:text-muted-foreground"}`}>
              <Star className="h-4 w-4" fill={fav ? "currentColor" : "none"} />
            </button>
            <ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:text-foreground transition-colors" />
          </div>
        )}
      </div>
      <h3 className={`mt-4 font-heading text-lg font-bold tracking-tight leading-snug ${soon ? "text-muted-foreground" : ""}`}>{tool.name}</h3>
      <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{tool.description}</p>
    </>
  );

  if (soon) {
    return (
      <div data-testid={`tool-card-${tool.slug}`} className="flex cursor-not-allowed flex-col border border-dashed border-border bg-muted/60 p-5">
        {inner}
      </div>
    );
  }

  return (
    <Link
      to={`/tool/${tool.slug}`}
      data-testid={`tool-card-${tool.slug}`}
      className="group relative flex flex-col border border-border bg-card p-5 transition-transform duration-200 ease-out hover:-translate-x-1 hover:-translate-y-1 hover:hard-shadow"
    >
      {inner}
    </Link>
  );
};
